import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  title: css`
    font-size: 24px;
    font-weight: 700;
    line-height: 27px;
    color: var(--colorScheme-text, #21201f);
  `,
}
